import { render, staticRenderFns } from "./quesScale.vue?vue&type=template&id=7f923203&scoped=true&"
import script from "./quesScale.vue?vue&type=script&lang=js&"
export * from "./quesScale.vue?vue&type=script&lang=js&"
import style0 from "./quesScale.vue?vue&type=style&index=0&id=7f923203&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f923203",
  null
  
)

export default component.exports